<!-- eslint-disable vuejs-accessibility/form-control-has-label -->
<script setup lang="ts">
import { useUpdatedReportStore } from '@src/store/report-store';
import { computed } from 'vue';

const props = defineProps<{
  fieldKey: string;
  editable?: boolean;
}>();

const reportStore = useUpdatedReportStore();

/**
 * Raw value stored in Pinia (ISO: YYYY-MM-DD or empty)
 */
const modelValue = computed(() => {
  return reportStore.getValue(props.fieldKey) ?? '';
});

/**
 * Write back to store
 */
function onInput(event: Event) {
  const target = event.target as HTMLInputElement;
  reportStore.setValue(props.fieldKey, target.value);
}

/**
 * Pretty display format (DD-Mon-YYYY)
 */
const formattedDisplay = computed(() => {
  const { value } = modelValue;
  if (!value) return 'DD-Mon-YYYY';

  const [year, month, day] = String(value).split('-');

  const months = [
    'JAN',
    'FEB',
    'MAR',
    'APR',
    'MAY',
    'JUN',
    'JUL',
    'AUG',
    'SEP',
    'OCT',
    'NOV',
    'DEC',
  ];

  return `${day}-${months[Number(month) - 1]}-${year}`;
});
</script>

<template>
  <input
    v-if="editable"
    type="date"
    class="date-picker"
    :value="modelValue"
    aria-label="DateInput"
    @input="onInput"
  >

  <p v-else class="date">
    {{ formattedDisplay }}
  </p>
</template>

<style scoped>
.date-picker {
  border: 1px solid #c4c4c4;
  border-radius: 5px;
  background: #fff;
  color: black;
  font-size: 12px;
  padding-left: 5px;
}

.date-picker::-webkit-inner-spin-button {
  display: none;
}

.date-picker::-webkit-calendar-picker-indicator {
  opacity: 0;
}

input.date-picker {
  border: 1px solid #c4c4c4;
  border-radius: 5px;
  font-size: 12px;
  padding-left: 5px;
  outline: none;
}

.date {
  font-weight: bold;
  font-size: 13px;
  color: black;
}
</style>
